export default "__VITE_ASSET__BfDPn2a8__"